import { apiCrm } from 'http/index';

class ProcessStageSettingService {
  async create(data) {
    return apiCrm.post('/process-stage-settings', data);
  }

  async update(data) {
    return apiCrm.put('/process-stage-settings', data);
  }

  async get(processId, stageId) {
    return apiCrm.get(`/process-stage-settings/${processId}/${stageId}`);
  }
}

export default new ProcessStageSettingService();
